import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import 'react-spring-bottom-sheet/dist/style.css';

import { useMount } from '@cutwise/utils';

import ErrorPage from '@/components/ErrorPage/ErrorPage';
import { MAIN_ROUTE, PRODUCT_ROUTE } from '@/constants/routes';
import DiamondPage from '@/routes/DiamondPage/DiamondPage';
import DiamondsListPage from '@/routes/DiamondsListPage/DiamondsListPage';
import NotFound from '@/routes/NotFound/NotFound';
import { useStore } from '@/stores/StoreProvider';
import CirclesLoader from '@/ui-kit/CirclesLoader/CirclesLoader';

import './App.module.scss';

function App() {
  const { initDictionaryStore, error, isReady } = useStore('dictionary');

  useMount(initDictionaryStore);

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (!isReady) {
    return <CirclesLoader />;
  }

  return (
    <Router>
      <Routes>
        <Route element={<DiamondsListPage />} path={MAIN_ROUTE} />

        <Route element={<DiamondsListPage />} path={`${MAIN_ROUTE}/:collectionId`} />

        <Route element={<DiamondPage />} path={`${PRODUCT_ROUTE}/:id`} />

        <Route element={<DiamondPage />} path={`${PRODUCT_ROUTE}/:id/:collectionId`} />

        <Route element={<NotFound />} path="*" />
      </Routes>
    </Router>
  );
}

export default observer(App);
